import {useFormContext} from '@yandex-delivery/form'

export function useSourcePointStationId() {
  const {watch} = useFormContext()

  const stationID = watch('sourcePoint.station.station_id')
  const addressID = watch('sourcePoint.station.address_id')

  return stationID || addressID
}
